module.exports = __webpack_public_path__ + "static/img/nayIngeral.17521c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nayIngeral.png
// module id = PNFb
// module chunks = 17